import * as types from './mutation-types'

export default {
  [types.SET_LISTA_NEGOCIADORES_USUARIO] (state, listaNegociadoresDoUsuario) {
    state.listaNegociadoresDoUsuario = listaNegociadoresDoUsuario
  },
  [types.SET_LISTA_PERMISSOES_USUARIO] (state, listaPermissoesHabilitadasDoUsuario) {
    state.listaPermissoesHabilitadasDoUsuario = listaPermissoesHabilitadasDoUsuario
  },
  [types.SET_POSSUI_NEGOCIADOR] (state, possuiNegociador) {
    state.possuiNegociador = possuiNegociador
  },
  [types.SET_LISTA_UNIDADES] (state, listaUnidadesDisponiveis) {
    state.listaUnidadesDisponiveis = listaUnidadesDisponiveis
  },
  [types.SET_LISTA_COORDENADORES] (state, listaCoordenadoresDisponiveis) {
    state.listaCoordenadoresDisponiveis = listaCoordenadoresDisponiveis
  },
  [types.SET_LISTA_CAPAS] (state, listaCapasDisponiveis) {
    state.listaCapasDisponiveis = listaCapasDisponiveis
  },
  [types.SET_LISTA_TIPOS_ACAO] (state, listaTiposDeAcaoDisponiveis) {
    state.listaTiposDeAcaoDisponiveis = listaTiposDeAcaoDisponiveis
  },
  [types.SET_DADOS_FORMULARIO_USUARIO] (state, formulario) {
    state.formulario = formulario
  },
  [types.SET_DADOS_RETORNO_USUARIO] (state, dadosRetorno) {
    state.dadosRetorno = dadosRetorno
  },
  [types.SET_FLAGS_DE_CONTROLE] (state, flagsDeControle) {
    state.flagsDeControle = flagsDeControle
  },
  [types.SET_LISTA_MERGE_PERMISSOES_USUARIO_SISTEMA] (state, listaMergeDasPermissoesDoUsuarioESistema) {
    state.listaMergeDasPermissoesDoUsuarioESistema = listaMergeDasPermissoesDoUsuarioESistema
  },
  [types.SET_DADOS_PERFIL_USUARIO] (state, dadosPerfil) {
    state.dadosPerfil = dadosPerfil
  },
  [types.SET_LISTA_ESTADOS] (state, listaEstadosDisponiveis) {
    state.listaEstadosDisponiveis = listaEstadosDisponiveis
  },
  [types.SET_DADOS_SALVOS_PERFIL_ADVOGADO] (state, dadosSalvosPerfilAdvogado) {
    state.dadosSalvosPerfilAdvogado = dadosSalvosPerfilAdvogado
  },
  [types.SET_DADOS_RETORNO_CADASTRO] (state, dadosRetornoDoCadastro) {
    state.dadosRetorno.sucesso = dadosRetornoDoCadastro.sucesso
    state.dadosRetorno.listaDeErros = dadosRetornoDoCadastro.listaDeErros
    state.dadosRetorno.mensagem = dadosRetornoDoCadastro.mensagem
  }
}
